exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user_icon[data-v-4e67b030]{font-size:2.083333rem;color:#4db22f;position:relative;top:.416667rem;cursor:pointer}.user-row-cla[data-v-4e67b030]{height:3.333333rem;line-height:3.333333rem;display:-webkit-box;display:-ms-flexbox;display:flex}.bio-icon-cla[data-v-4e67b030]{margin-left:2.5rem;font-size:2.083333rem}.active-cla[data-v-4e67b030]{color:#4db22f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e67b030","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/tenantManager/companyInfo/employeeDetail.vue
// module id = EgHt
// module chunks = 6